<div class="flex-row padding-top">
  <div class="flex-1"></div>
  <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="form-content flex-1">
    <h2 class="center-text">Forgot Password</h2>

    <mat-form-field appearance="outline">
      <mat-label>Email Address</mat-label>
      <input matInput type="text" formControlName="emailAddress">
      @if (formControls.emailAddress.hasError('required')) {
        <mat-error>Email is required.</mat-error>
      }
      @if (formControls.emailAddress.hasError('email')) {
        <mat-error>Email is invalid.</mat-error>
      }
    </mat-form-field>

    <div class="form-group">
      @if (!loading) {
        <button mat-raised-button style="border-radius: 4px" color="primary" [disabled]="loading || !forgotPasswordForm.valid" class="btn btn-primary span-form">
          Send Email
        </button>
      }
      <div class="flex-row">
        <div class="flex-1"></div>
        @if (loading) {
          <mat-spinner></mat-spinner>
        }
        <div class="flex-1"></div>
      </div>
    </div>
  </form>
  <div class="flex-1"></div>
</div>
